import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class WaitingRoomService {
  private baseUrl = environment.apibaseUrl;

  constructor(private http: HttpClient) { }

  getpatientList(WaitingRoomLevelType) {
    return this.http.get(this.baseUrl + '/waitingRoom/waitingroom-info?waitingRoomType=' + WaitingRoomLevelType);
  }

  getPatientCount(waitingRoomType) {
    return this.http.get(this.baseUrl + '/waitingRoom/queue-size?waitingRoomType=' + waitingRoomType);
  }

  UpdateStartTime(waitingRoomId) {
    return this.http.post(this.baseUrl + '/waitingRoom/start-time-update', {
      waitingRoomId: waitingRoomId
    });
  }

  UpdateEndTime(waitingRoomId) {
    return this.http.post(this.baseUrl + '/waitingRoom/end-time-update', {
      waitingRoomId: waitingRoomId
    });
  }

  // Reconnect

  GetHoldingCalls() {
    return this.http.get(this.baseUrl + '/waitingRoom/holdingCall');
  }

  getDbSessionId(waitingRoomId = 0, appointmentId = 0) {
    return new Promise<number>((resolve, reject) => {
      this.http.get(this.baseUrl + '/waitingRoom/get/sessionId?waitingRoomId=' + waitingRoomId
       + '&appointmentId=' + appointmentId).subscribe((data: number) => {
        resolve(data);
      });
    });
  }

}
